import HttpError from './http';

export default class ConfigTesterAssetValidationError extends HttpError {
	public validationErrorType: ConfigTester.ValidationErrorType;

	constructor(
		status: number,
		statusText: string,
		errorType: ConfigTester.ValidationErrorType) {
			super(status, statusText, null);
			this.validationErrorType = errorType;
			Object.setPrototypeOf(this, ConfigTesterAssetValidationError.prototype);
	}
}

export function isConfigTesterValidationError(
	error: HttpError,
	currentDeployType: ConfigTester.DeployType): boolean {
		if (error instanceof ConfigTesterAssetValidationError) {
			switch (error.validationErrorType) {
				case 'INSTANCE_NOT_FOUND':
					return currentDeployType === 'LOAD';
				case 'SUFFIX_UNAVAILABLE':
					return currentDeployType === 'TEST';
				case 'UNEXPECTED':
					return true;
				default:
					return false;
			}
		} else {
			return false;
		}
}

export function throwInstanceNotFoundError() {
	throw new ConfigTesterAssetValidationError(
		404,
		'Instance not found!',
		'INSTANCE_NOT_FOUND');
}

export function throwInstanceAlreadyExistsError() {
	throw new ConfigTesterAssetValidationError(
		400,
		'Suffix unavailable - instance already exists!',
		'SUFFIX_UNAVAILABLE');
}

export function throwGenericValidationError(error: Error) {
	throw new ConfigTesterAssetValidationError(
		400,
		`Unable to verify instance: ${error.message}`,
		'UNEXPECTED');
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/errors/validation.ts